/**
 * A Component to show hour summations in the banner of the planboard.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { Resource } from '../../domain/helpers/resource';
import * as moment from 'moment';
import { durationToText } from '../../core/helpers/durationToText';
import { DomainService } from '../../domain.service';
import { EntityQuery } from 'breeze-client';
import { GridService } from '../grid.service';
import { AbstractBase } from '../../core/helpers/abstract-base';
/**
 * A Component to show hour summations in the banner of the planboard.
 * @export
 * @class PlanboardRowInfoComponent
 * @implements {OnDestroy}
 */
var PlanboardRowInfoComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PlanboardRowInfoComponent, _super);
    /**
     * Creates an instance of PlanboardRowInfoComponent.
     * @param {DomainService} domainService The domain service to query for the contract hours.
     */
    function PlanboardRowInfoComponent(domainService, gridService) {
        var _this = _super.call(this) || this;
        _this.domainService = domainService;
        _this.gridService = gridService;
        // The placeholder for the loading state
        _this.loadingPlaceholder = '??:??';
        /**
         * Reference to the Resource of this PlanboardRowInfoComponent
         * @private
         * @type {Resource}
         */
        _this._resource = null;
        /**
         * Gets, sets the contract hours displayed.
         */
        _this.contract = '';
        /**
         * Gets, sets the displayed value.
         */
        _this.work = '';
        /**
         * Gets, sets the displayed hours of leave.
         */
        _this.absence = '';
        /**
         * Gets, sets the loading flag
         * so that the loading animation is shown on the appropriate moment.
         */
        _this.loading = false;
        _this.subscriptionPool.add(_this.gridService.stateChanged.subscribe(function () {
            if (_this._resource) {
                _this.refreshValueWith(_this._resource.$getRow());
            }
        }));
        return _this;
    }
    Object.defineProperty(PlanboardRowInfoComponent.prototype, "resource", {
        /**
         * Sets the Resource
         */
        set: function (value) {
            var _this = this;
            if (value === this._resource) {
                return;
            }
            if (this._resource) {
                this.subscriptionPool.unsubscribeAll();
                this.subscriptionPool.add(this.gridService.stateChanged.subscribe(function () {
                    if (_this._resource) {
                        _this.refreshValueWith(_this._resource.$getRow());
                    }
                }));
            }
            this._resource = value;
            if (value == null) {
                return;
            }
            this.subscriptionPool.add(value.onRowChanged.subscribe(function (result) {
                _this.refreshValueWith(result);
            }));
            this.refreshValueWith(this._resource.$getRow());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlanboardRowInfoComponent.prototype, "showInfo", {
        /**
         * Gets the show info flag.
         * @readonly
         * @type {boolean} Is true when the horizon level is "week", otherwise false.
         */
        get: function () {
            return this.gridService.level.name === 'week' || this.gridService.level.name === 'day';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * A refresh the current value with a new dataset
     * @private
     * @param {DataSet} data
     * @returns
     */
    PlanboardRowInfoComponent.prototype.refreshValueWith = function (data) {
        var _this = this;
        this.work = this.loadingPlaceholder;
        this.absence = this.loadingPlaceholder;
        if (data == null) {
            return;
        }
        var parameters = data.queryOptions.parameters;
        // Vanwege IE, gebruik moment voor string naar date.
        var start = moment(parameters['start']).toDate();
        if (this.gridService.startDate.toDate().getDate() !== start.getDate()) {
            // Vergelijk getDate() i.p.v. getTime()
            return;
        }
        var secondsWork = 0;
        var secondsAbsence = 0;
        data.items.map(function (item) { return item; }).filter(function (item) { return item.Item != null; }).forEach(function (item) {
            switch (item.ItemClass) {
                case 'Appointment':
                    secondsAbsence += item.Item['overlapEffort'](_this.gridService.startDate, _this.gridService.endDate);
                    break;
                case 'Assignment':
                case 'Attendant':
                    secondsWork += item.Item['overlapEffort'](_this.gridService.startDate, _this.gridService.endDate);
                    break;
            }
        });
        var minutes = Math.round(secondsWork / 60);
        this.work = durationToText(moment.duration(Math.abs(minutes), 'minutes'));
        if (minutes < 0) {
            this.work = '-' + this.work;
        }
        minutes = Math.round(secondsAbsence / 60);
        this.absence = durationToText(moment.duration(Math.abs(minutes), 'minutes'));
        if (minutes < 0) {
            this.absence = '-' + this.absence;
        }
        if (this.gridService.level.name !== 'week') {
            return;
        }
        this.contract = this.loadingPlaceholder;
        this.loading = true;
        var query = new EntityQuery('ContractHoursOn');
        query.parameters = { oid: parameters['oid'], view: start };
        this.domainService.entityManager.executeQuery(query).then(function (response) {
            if (_this._resource == null || _this._resource.Oid !== response.results[0]['oid']) {
                // Fix issue: Soms worden er andere uren getoond bij de banner van de medewerker in planbord #4161
                // Door een andere datum te kiezen, 1 sec wachten, dan andere pagina kiezen, kan:
                // Oorsponkelijke query later binnen komen nadat de medewerker van PlanboardRowInfoComponent verandert is.
                _this.loading = false;
                return;
            }
            _this.contract = durationToText(moment.duration(response.results[0]['contract']));
            _this.loading = false;
        });
    };
    return PlanboardRowInfoComponent;
}(AbstractBase));
export { PlanboardRowInfoComponent };
